import React, { useEffect } from 'react';


const EditProject = () => {
    useEffect(() => {
        // Initialize intl-tel-input when the component mounts
        const input = document.querySelector("#mobileprojectedit");
        const iti = window.intlTelInput(input, {
            preferredCountries: ["us", "gb", "in", "au"],  // Customize preferred countries
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.8/build/js/utils.js"  // For better validation and formatting
        });

        // Cleanup the intl-tel-input when the component unmounts
        return () => {
            if (iti) {
                iti.destroy();
            }
        };
    }, []);

    return (
        <div>
            {/* Modal */}
            <div className="modal fade" id="editprojectModal" tabindex="-1" aria-labelledby="editprojectModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title font-bold" id="editprojectModalLabel">Edit Project</h5>
                            <button type="button" className="btn-close btn-close-primary size-10" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="first-section">
                                <h6 className='font-semibold mb-3 '>Basic Details:</h6>
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label htmlFor="name" className="form-label">Name (*)</label>
                                        <input type="text" className="form-control" id="name" placeholder="Enter project name" />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="code" className="form-label">Code (*)</label>
                                        <input type="text" className="form-control" id="code" placeholder="Enter  Code" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="s_title" className="form-label">Sub Title </label>
                                        <input type="text" className="form-control" id="s_title" placeholder="Enter Sub Title" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="address" className="form-label">Address </label>
                                        <input type="text" className="form-control" id="address" placeholder="Enter Address" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="brochure" className="form-label">Brochure </label>
                                        <input type="text" className="form-control" id="brochure" placeholder="Enter Brochure Link" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="walkthrogh" className="form-label">Walk through </label>
                                        <input type="text" className="form-control" id="walkthrogh" placeholder="Enter Walk through" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="v_tour" className="form-label">Virtual Tour </label>
                                        <input type="text" className="form-control" id="v_tour" placeholder="Enter link" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="website" className="form-label">Website </label>
                                        <input type="text" className="form-control" id="website" placeholder="Enter Website Url" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="location" className="form-label">Location </label>
                                        <input type="text" className="form-control" id="location" placeholder="Enter Location" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="wp" className="form-label">Whats App No </label>
                                        <input type="text" className="form-control" id="wp" placeholder="Enter Whats App No" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="mobileproject" className="form-label">Mobile No</label>
                                        <input type="text" className="form-control" id="mobileprojectedit" placeholder="Enter Mobile No" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="insta" className="form-label">Instagram</label>
                                        <input type="text" className="form-control" id="insta" placeholder="Enter Instagram" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="fb" className="form-label">Facebook</label>
                                        <input type="text" className="form-control" id="fb" placeholder="Enter Facebook" />
                                    </div>
                                </div>
                              
                            </div>

                            {/* Client Details Section */}
                         
                        </div>

                        <div className="modal-footer justify-content-between p-3" style={{ borderTop: "2px solid #f0f0f0" }}>
                            <button
                                type="button"
                                className="btn btn-outline-primary d-flex align-items-center gap-2"
                                style={{ borderRadius: "30px", padding: "0.5rem 1.5rem" }}
                                data-bs-dismiss="modal"
                            >
                                <i className="bi bi-x-circle"></i> Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-gradient d-flex align-items-center gap-2"
                                style={{ borderRadius: "30px", padding: "0.5rem 1.5rem", background: "linear-gradient(90deg, #6a11cb 0%, #313265 100%)", color: "white", border: "none" }}
                            >
                                <i className="bi bi-plus-circle"></i> Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditProject;
